import React from 'react';

const Footer = ({ language }) => {
  const texts = {
    lt: {
      blurb: 'Filmviewing yra skaitmeninė filmų peržiūros paslauga: nuotaikos takeliai ir trumpos pastabos prieš seansą.',
      lanes: 'Takeliai',
      path: 'Eiga',
      note: 'Pastaba',
      terms: 'Sąlygos ir nuostatos',
      rights: 'Visos teisės saugomos.',
    },
    en: {
      blurb: 'Filmviewing is a digital film viewing service: mood lanes and short notes before a screening.',
      lanes: 'Lanes',
      path: 'Path',
      note: 'Note',
      terms: 'Terms and conditions',
      rights: 'All rights reserved.',
    },
  };

  const t = texts[language];

  return (
    <footer className="border-t border-white/10 bg-ink">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 md:grid-cols-3">
        <div>
          <p className="font-heading text-2xl">Filmviewing</p>
          <p className="mt-4 text-sm leading-relaxed text-sand">{t.blurb}</p>
        </div>
        <div>
          <ul className="space-y-2 text-sm text-sand">
            <li><a href="#section-2" className="hover:text-paper">{t.lanes}</a></li>
            <li><a href="#section-3" className="hover:text-paper">{t.path}</a></li>
            <li><a href="#section-4" className="hover:text-paper">{t.note}</a></li>
          </ul>
        </div>
        <div className="text-sm text-sand md:text-right">
          <p><a href="/terms.html" className="hover:text-paper">{t.terms}</a></p>
        </div>
      </div>
      <div className="border-t border-white/10 px-5 py-6 text-center text-xs text-sand">
        © {new Date().getFullYear()} Filmviewing. {t.rights}
      </div>
    </footer>
  );
};

export default Footer;
